import React from "react";
import { Link } from "react-router-dom";
import { Form, Button, Container, Row, Col, Tab, Nav } from "react-bootstrap";


import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import CancelButton from "presentation/components/buttons/cancel";

import GeneralTabResponsibleForm from "presentation/pages/responsibles/elements/form-tabs/general";
import ExtraTabResponsibleForm from "presentation/pages/responsibles/elements/form-tabs/extra";
import AddressTabResponsibleForm from "presentation/pages/responsibles/elements/form-tabs/address";
import PhoneTabResponsibleForm from "presentation/pages/responsibles/elements/form-tabs/phone";

import racesService from "presentation/services/races";
import localitiesService from "presentation/services/localities";
import countriesService from "presentation/services/countries";
import familyRelationshipsService from "presentation/services/family-relationships";


class ResponsibleForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            localLoading: true,
            localError: false,
            message: '',
            races: [],
            localities: [],
            countries: [],
            familyRelationships: []
        }
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => {

        let races = [];
        let countries = [];
        let localities = [];
        let familyRelationships = [];

        await racesService.findAll().then((result) => {
            races = result;
        });

        await localitiesService.findAll().then((result) => {
            localities = result;
        });

        await countriesService.findAll().then((result) => {
            countries = result;
        });

        await familyRelationshipsService.findAll().then((result) => {
            familyRelationships = result;
        });

        this.setState({ localLoading: false, localities: localities, countries: countries, races: races, familyRelationships: familyRelationships });
    }

    render() {

        let {
            dependentId,
            studentId,
            loading,
            message,
            form,
            addressForm,
            handleChange,
            handleSubmit,
            component,
            phones,
        } = this.props;

        let {
            localLoading,
            localError,
            localities,
            countries,
            races,
            familyRelationships
        } = this.state;

        let childrenParams = {
            component: component,
            form: form,
            addressForm: addressForm,
            handleChange: handleChange,
            localities: localities,
            countries: countries,
            races: races,
            phones: phones,
            familyRelationships: familyRelationships,
            loading: loading
        };

        return (
            <Form className="mb-5">
                {loading === true || localLoading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                {(localLoading === false && localError === true) && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {
                    loading === false && localLoading === false && (
                        <Container>
                            <Row>
                                <Col>
                                    <Tab.Container id="left-tabs" defaultActiveKey="general">
                                        <Row>
                                            <Col sm={2}>
                                                <Nav variant="pills" className="flex-column">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="general">Dados básicos</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="extra">Dados extra</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="address">Endereço</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="phone">Telefone</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                                <hr />
                                                <div>
                                                    <div className="form mt-2">
                                                        <strong>Aluno</strong> <br />
                                                        {`${form.studentRegistration} - ${form.studentName} `}
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col sm={10}>
                                                <Container>
                                                    <Row>
                                                        <Col>
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="general">
                                                                    <GeneralTabResponsibleForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="extra">
                                                                    <ExtraTabResponsibleForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="address">
                                                                    <AddressTabResponsibleForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="phone">
                                                                    <PhoneTabResponsibleForm {...childrenParams} />
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <div className="mt-3">
                                                                <CancelButton
                                                                    containerProps={{
                                                                        as: Link,
                                                                        to: `/responsaveis/${dependentId}/${studentId}`
                                                                    }}
                                                                />
                                                                <Button disabled={loading} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </Col>
                            </Row>
                        </Container>
                    )}
            </Form>
        );
    };
}

export default ResponsibleForm;